import React from 'react';
import {
  Typography,
  Box,
  IconButton,
  Tooltip,
  ListItem,
  ListItemText,
} from '@mui/material';
import {
  Delete as DeleteIcon,
  RestoreFromTrash as RestoreIcon,
} from '@mui/icons-material';
import useAppStore from 'store/useAppStore';
import api from 'services/api';
const RenderHistoryItem = ({ data, fullScriptId, setEditedFullScript }) => {
  const showNotification = useAppStore((state) => state.showNotification);
  const [deleteDBFullScript, { isLoading: isDeleteDBFullScriptLoading }] =
    api.endpoints.deleteDBFullScript.useMutation();
  const project_id = useAppStore((state) => state.selectedProject.project_id);
  const user_id = useAppStore((state) => state.user.id);
  const comp_name = useAppStore((state) => state.user.company);
  const handleDelete = async () => {
    deleteDBFullScript({
      full_script_id: fullScriptId,
      project_id,
      user_id,
      comp_name,
      edit_time: data.edit_time,
    })
      .unwrap()
      .then(() => {
        showNotification('刪除成功！', 'success');
      })
      .catch((error) => {
        showNotification(error.message || '刪除失敗', 'error');
      });
  };
  const handleRestoreButtonClick = () => {
    setEditedFullScript(data.script);
  };
  return (
    <ListItem
      sx={{ border: '1px solid #e0e0e0', borderRadius: 1, mb: 1, gap: 2 }}
    >
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold">
              {data.script_name}
            </Typography>
          </Box>
        }
        secondary={
          <Tooltip
            title={data.script.replace(/<br>/g, '\n')}
            placement="top"
            classes={{
              tooltip: 'whitespace-pre-wrap max-w-[400px]',
            }}
          >
            <Box
              component="span"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'text.secondary',
                fontSize: '0.875rem',
                lineHeight: 1.43,
                display: 'block',
              }}
            >
              {data.script.replace(/<br>/g, '\n')}
            </Box>
          </Tooltip>
        }
      />
      <Box sx={{ display: 'flex', flex: '0 0 auto', gap: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {data.edit_time}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Tooltip title="覆蓋當前內容">
          <IconButton size="small" onClick={handleRestoreButtonClick}>
            <RestoreIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="刪除版本">
          <IconButton
            size="small"
            onClick={handleDelete}
            color="error"
            loading={isDeleteDBFullScriptLoading}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </ListItem>
  );
};
export default RenderHistoryItem;
